import { VDialog } from 'vuetify/lib/components/VDialog';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VDialog,{attrs:{"fullscreen":"","hide-overlay":""},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_c('div',{staticClass:"progress-wrap",staticStyle:{"height":"80%"}},[_c(VProgressCircular,{attrs:{"size":120,"width":10,"color":_vm.color,"indeterminate":""}},[_vm._v("\n\t\t\t"+_vm._s(_vm.note)+"\n\t\t")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }